import { render, staticRenderFns } from "./NPADocumentList.vue?vue&type=template&id=35e52c5a&"
import script from "./NPADocumentList.vue?vue&type=script&lang=js&"
export * from "./NPADocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports